<div>
  <form [formGroup]="vestingCategoryForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6">
    <!-- Category Name Field -->
    <div class="flex flex-col gap-2">
      <label for="categoryName" class="font-medium">{{
        'projectEdit.vestingCategories.category' | translate
      }}</label>
      <input
        id="categoryName"
        type="text"
        pInputText
        [formControl]="categoryControl"
        [placeholder]="'projectEdit.vestingCategories.categoryPlaceholder' | translate"
        class="w-full"
      />
      @if (categoryControl.invalid && categoryControl.touched) {
      <p-message severity="error">
        {{ getCategoryErrorMessage() }}
      </p-message>
      }
    </div>

    <!-- Wallet Address Field -->
    <div class="flex flex-col gap-2">
      <label for="walletAddress" class="font-medium">{{
        'projectEdit.vestingCategories.walletAddress' | translate
      }}</label>
      <input
        id="walletAddress"
        type="text"
        pInputText
        [formControl]="walletAddressControl"
        [placeholder]="'projectEdit.vestingCategories.walletAddressPlaceholder' | translate"
        class="w-full font-mono"
      />
      @if (walletAddressControl.invalid && walletAddressControl.touched) {
      <p-message severity="error">
        {{ getWalletAddressErrorMessage() }}
      </p-message>
      }
    </div>

    <!-- Cliff Period Field (in months) -->
    <div class="flex flex-col gap-2">
      <label for="cliffPeriod" class="font-medium">{{
        'projectEdit.vestingCategories.cliffPeriodLabel' | translate
      }}</label>
      <p-inputNumber
        id="cliffPeriod"
        [formControl]="cliffPeriodControl"
        [placeholder]="'projectEdit.vestingCategories.cliffPeriodPlaceholder' | translate"
        [min]="1"
        [step]="1"
        mode="decimal"
        [useGrouping]="false"
        class="w-full"
      ></p-inputNumber>
      @if (cliffPeriodControl.invalid && cliffPeriodControl.touched) {
      <p-message severity="error">
        {{ getCliffPeriodErrorMessage() }}
      </p-message>
      }
    </div>

    <!-- Vesting Duration Field (in months) -->
    <div class="flex flex-col gap-2">
      <label for="vestingDuration" class="font-medium">{{
        'projectEdit.vestingCategories.vestingDurationLabel' | translate
      }}</label>
      <p-inputNumber
        id="vestingDuration"
        [formControl]="vestingDurationControl"
        [placeholder]="'projectEdit.vestingCategories.vestingDurationPlaceholder' | translate"
        [min]="1"
        [step]="1"
        mode="decimal"
        [useGrouping]="false"
        class="w-full"
      ></p-inputNumber>
      @if (vestingDurationControl.invalid && vestingDurationControl.touched) {
      <p-message severity="error">
        {{ getVestingDurationErrorMessage() }}
      </p-message>
      }
    </div>

    <!-- Releasing Frequency Field -->
    <div class="flex flex-col gap-2">
      <label for="releasingFrequency" class="font-medium">{{
        'projectEdit.vestingCategories.releasingFrequency' | translate
      }}</label>
      <select
        id="releasingFrequency"
        [formControl]="releasingFrequencyControl"
        class="p-2 border border-gray-600 bg-surface-800 rounded text-white w-full"
      >
        <option value="daily">Daily</option>
        <option value="weekly">Weekly</option>
        <option value="monthly">Monthly</option>
        <option value="quarterly">Quarterly</option>
        <option value="yearly">Yearly</option>
      </select>
      @if (releasingFrequencyControl.invalid && releasingFrequencyControl.touched) {
      <p-message severity="error">
        {{ getReleasingFrequencyErrorMessage() }}
      </p-message>
      }
    </div>

    <!-- TGE Unlock Field -->
    <div class="flex flex-col gap-2">
      <label for="tgeUnlock" class="font-medium">{{
        'projectEdit.vestingCategories.tgeUnlock' | translate
      }}</label>
      <p-inputNumber
        id="tgeUnlock"
        [formControl]="tgeUnlockControl"
        [placeholder]="'projectEdit.vestingCategories.tgeUnlockPlaceholder' | translate"
        [min]="0"
        [max]="100"
        [step]="1"
        mode="decimal"
        [useGrouping]="false"
        suffix="%"
        class="w-full"
      ></p-inputNumber>
      @if (tgeUnlockControl.invalid && tgeUnlockControl.touched) {
      <p-message severity="error">
        {{ getTgeUnlockErrorMessage() }}
      </p-message>
      }
    </div>

    <!-- First Claim Available Field -->
    <div class="flex flex-col gap-2">
      <label for="firstClaim" class="font-medium">{{
        'projectEdit.vestingCategories.firstClaim' | translate
      }}</label>
      <p-inputNumber
        id="firstClaim"
        [formControl]="firstClaimValueControl"
        [placeholder]="'projectEdit.vestingCategories.firstClaimPlaceholder' | translate"
        [min]="0"
        [step]="1"
        mode="decimal"
        [useGrouping]="false"
        class="w-full"
      ></p-inputNumber>
      @if (firstClaimValueControl.invalid && firstClaimValueControl.touched) {
      <p-message severity="error">
        {{ getFirstClaimErrorMessage() }}
      </p-message>
      }
    </div>

    <!-- Action Buttons -->
    <div class="flex flex-col md:flex-row gap-4 mt-6">
      <p-button
        type="submit"
        [label]="
          isEdit
            ? ('projectEdit.vestingCategories.updateCategory' | translate)
            : ('projectEdit.vestingCategories.addCategory' | translate)
        "
        [disabled]="vestingCategoryForm.invalid"
      />

      <p-button
        type="button"
        [label]="'projectEdit.cancel' | translate"
        severity="secondary"
        [outlined]="true"
        (onClick)="onCancel()"
      />
    </div>
  </form>
</div>
